class VariantSelector extends CustomElement {
  props = {
    value: null,
    options: [],
  };

  constructor() {
    super();

    this.changeEvent = new Event("change");
  }

  get refs() {
    return {
      $select: this.$el.find("select"),
    };
  }

  render() {
    const { value, options } = this.props;

    const availOptions = options.filter(({ available }) => !!available);

    const template = `
    <select>
      ${availOptions.map((o) => `<option ${value === o.id ? "selected" : ""} data-price="${o.price / 100}" data-original-price="${o.compare_at_price / 100}" data-sku="${o.sku}" value="${o.id}">${o.title}</option>`).join("")}
    </select>`;

    this.innerHTML = template;
  }

  async mounted() {
    const { $select } = this.refs;

    $select.change(this.handleSelectVariant.bind(this));

    await ResourceCoordinator.requestVendor("Select2");

    $select.select2({
      minimumResultsForSearch: -1,
      dropdownAutoWidth: true,
      width: "auto",
    });
  }

  onDisabledChange(isDisabled) {
    super.onDisabledChange(isDisabled);

    const { $select } = this.refs;

    $select.attr("disabled", !!isDisabled);
  }

  handleSelectVariant(e) {
    this.dispatchEvent(this.changeEvent);
  }

  selectVariant(value) {
    const { $select } = this.refs;
    $select.val(value).trigger("change");
  }
}

customElements.define("variant-selector", VariantSelector);

class CartVariantSelector extends VariantSelector {
  props = {
    key: 0,
    value: null,
    options: [],
    quantity: 0,
    freeProducts: [],
  };

  async handleSelectVariant(e) {
    super.handleSelectVariant(e);

    const { key, quantity, freeProducts, options } = this.props;

    const selectedOption = $(this).find(":selected");
    const variantId = selectedOption.val();
    const variant = options.find(
      (item) => String(item.id) === String(variantId),
    );

    await this.closest("cart-drawer-items").switchVariant({
      key,
      variant,
      quantity,
      variantId,
      freeProducts,
    });
  }
}

customElements.define("cart-variant-selector", CartVariantSelector);

class QuantityAdjusterButton extends CustomButton {
  props = {
    size: null,
    name: "",
  };

  render() {
    const { name, size } = this.props;

    const template = `
        <svg class="border-2 border-[var(--color-neutral-900)] rounded-full" width="${size}" height="${size}" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          ${
            name === "plus"
              ? `
                <path d="M10 6.66699V13.3337" fill="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.66699 10H13.3337" fill="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />`
              : `
              <path d="M6.66699 10H13.3337" fill="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            `
          }
      </svg>
    `;

    this.$el.html(template);
  }

  onDisabledChange(isDisabled) {
    this.$el[!!isDisabled ? "addClass" : "removeClass"]("is-disabled");
  }
}

customElements.define("quantity-adjuster-button", QuantityAdjusterButton);

class QuantityAdjuster extends CustomElement {
  props = {
    index: 0,
    size: 36,
    min: 1,
    max: null,
    inventoryPolicy: "",
  };

  get refs() {
    return {
      minusBtn: this.querySelector(`quantity-adjuster-button[\\:name=minus]`),
      plusBtn: this.querySelector(`quantity-adjuster-button[\\:name=plus]`),
    };
  }

  beforeMount() {
    const { index } = this.props;

    this.changeEvent = new Event("change", { bubbles: true });

    this.$el.addClass("quantity-adjuster");
    this.$el.attr("id", `Drawer-quantity-${index + 1}`);
    this.$el.attr("name", "updates[]");
    this.$el.attr("data-index", index + 1);
  }

  async mounted() {
    this.$val = this.$el.find(".quantity-adjuster__value");

    this.checkThreshold(this.value);

    this.$el.find("quantity-adjuster-button").click((e) => {
      e.preventDefault();

      this.onButtonClick($(e.currentTarget));
    });

    await ResourceCoordinator.requestVendor("TippyDependency");
    await ResourceCoordinator.requestVendor("Tippy");

    tippy("quantity-adjuster-button.is-disabled[\\:name=plus]", {
      content: "在庫切れ",
    });
  }

  onValueChange(val) {
    const isExceed = this.checkThreshold(val);

    if (isExceed) return;

    this.$val?.text(val);
  }

  isNumber(n) {
    return typeof n === "number" && isFinite(n);
  }

  checkThreshold(val) {
    const { min, max, inventoryPolicy } = this.props;
    const { minusBtn, plusBtn } = this.refs;

    if (!minusBtn || !plusBtn) return;

    if (inventoryPolicy === "continue") return true;

    const minThresholdExceed = this.isNumber(min) && val <= min;
    const maxThresholdExceed = this.isNumber(max) && val >= max;

    minusBtn.disabled = !!minThresholdExceed;
    plusBtn.disabled = !!maxThresholdExceed;

    if (minThresholdExceed || maxThresholdExceed) {
      this.value = Math.min(Math.max(val, min), max);

      return false;
    }

    return true;
  }

  render() {
    const { size } = this.props;

    const template = `
        <quantity-adjuster-button data-test="quantity-minus" :name="minus" :size="${size}"></quantity-adjuster-button>
        <p data-test="quantity-value" class="quantity-adjuster__value">${this.value}</p>
        <quantity-adjuster-button data-test="quantity-plus" :name="plus" :size="${size}"></quantity-adjuster-button>
    `;

    this.$el.html(template);
  }

  onButtonClick($button) {
    const previousValue = this.$val.text();

    this.value =
      $button.attr(":name") === "plus" ? +this.value + 1 : +this.value - 1;

    if (+previousValue !== +this.value) this.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-adjuster", QuantityAdjuster);
